import { Layout, Detectors } from "components"
export const Detector = () => {
 return (
  <Layout>
   <Detectors />
  </Layout>
 )
}
